import React from "react";
import { useNavigate } from "react-router-dom";

import { BsFillPlayFill } from "react-icons/bs";

import book from "../assets/images/yellow.png";

const Main = () => {
  const navigate = useNavigate();
  return (
    <div className="relative overflow-hidden bg-[#FFF9F4] pt-40">
      {/* Floating Shapes */}

      <div className="absolute top-16 left-10 w-16 h-16 bg-[#FFD93D] rounded-full opacity-30 animate-bounce"></div>

      <div className="absolute top-32 right-16 w-10 h-10 bg-[#FF6B6B] rounded-full opacity-30 animate-pulse"></div>

      <div className="absolute bottom-20 left-1/3 w-12 h-12 bg-[#6BCB77] rounded-full opacity-30 animate-ping"></div>

      <div className="absolute top-20 right-1/3 w-8 h-8 bg-[#9B5DE5] rounded-full opacity-30"></div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}

          <div>
            <div className="inline-block bg-[#FFE4D6] text-[#FF6B6B] px-5 py-2 rounded-full font-semibold mb-6">
              📚 Welcome to Bhavya Publications
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#4D96FF] leading-tight">
              Make Learning
              <span className="text-[#FF6B6B]"> Fun</span> with Amazing Books 🚀
            </h1>

            <p className="text-gray-600 text-lg mt-6 leading-8">
              Discover colourful, interactive and engaging books designed to
              make learning enjoyable for every child.
            </p>

            <div className="flex gap-5 mt-10">
              <button
                onClick={() => navigate("/explore-books")}
                className="
px-8
py-4
rounded-full
bg-gradient-to-r
from-[#4D96FF]
to-[#9B5DE5]
text-white
font-bold
shadow-lg
hover:scale-105
transition
"
              >
                Explore Books 📚
              </button>

              <button
                onClick={() => navigate("/why-bhavya")}
                className="
  flex
  items-center
  gap-3
  px-6
  py-4
  rounded-full
  bg-white
  shadow-lg
  hover:scale-105
  hover:shadow-xl
  transition-all
  duration-300
  "
              >
                {/* <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#FF6B6B] to-[#FFD93D] flex items-center justify-center text-white"> */}
                  {/* <BsFillPlayFill size={22} /> */}
                {/* </div> */}

                <span className="font-semibold">✨ Why Choose BhavyaPublications?</span>
              </button>
            </div>
          </div>

          {/* Right Side Image */}

          <div className="relative hidden md:flex justify-center items-center h-[500px]">
            {/* Center */}

            <div className="w-64 h-64 rounded-full bg-gradient-to-r from-[#FFD93D] to-[#FF6B6B] opacity-20"></div>

            {/* Book 1 */}

            <div className="absolute top-8 left-10 bg-white p-5 rounded-3xl shadow-2xl rotate-[-15deg] hover:rotate-0 hover:scale-110 transition duration-500">
              <div className="text-7xl">📘</div>
            </div>

            {/* Book 2 */}

            <div className="absolute top-24 right-10 bg-white p-5 rounded-3xl shadow-2xl rotate-[15deg] hover:rotate-0 hover:scale-110 transition duration-500">
              <div className="text-7xl">📙</div>
            </div>

            {/* Book 3 */}

            <div className="absolute bottom-20 left-14 bg-white p-5 rounded-3xl shadow-2xl rotate-[10deg] hover:rotate-0 hover:scale-110 transition duration-500">
              <div className="text-7xl">📗</div>
            </div>

            {/* Book 4 */}

            <div className="absolute bottom-10 right-10 bg-white p-5 rounded-3xl shadow-2xl rotate-[-10deg] hover:rotate-0 hover:scale-110 transition duration-500">
              <div className="text-7xl">📕</div>
            </div>

            {/* Center Book */}

            <div className="absolute bg-white p-8 rounded-full shadow-2xl hover:scale-110 transition duration-500">
              <div className="text-8xl">📚</div>
            </div>

            {/* Stars */}

            <div className="absolute top-0 right-28 text-5xl animate-pulse">
              ⭐
            </div>

            <div className="absolute bottom-0 left-24 text-4xl animate-bounce">
              🏜️
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
